import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinTanggalMerah = createAsyncThunk(
    "tanggalMerah/getMin",
    async ({search}, thunkAPI) => {

        const config = {
            headers: {Authorization: "Bearer " + user.Token},
            params: {"search": search},
        };
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL+"master/holidays/min",
                config
            );
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.TanggalMerahID,
                        label: item.TanggalMerahName,
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getTanggalMerah = createAsyncThunk(
    "tanggalMerah/get",
    async ({start, count, search}, thunkAPI) => {

        const config = {
            headers: {'Authorization': `Bearer ` + user.Token},
            params: {"start": start, "count": count, "search": search},
        };
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL+"master/holidays",
                config
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertTanggalMerah = createAsyncThunk(
    "tanggalMerah/insert",
    async (obj, thunkAPI) => {
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"master/holidays",
                obj,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateTanggalMerah = createAsyncThunk(
    "tanggalMerah/update",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.put(
                process.env.REACT_APP_API_URL+"master/holidays",
                obj,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const tanggalMerahSlice = createSlice({
    name: "tanggalMerah",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinTanggalMerah.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinTanggalMerah.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinTanggalMerah.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getTanggalMerah.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getTanggalMerah.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getTanggalMerah.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertTanggalMerah.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertTanggalMerah.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertTanggalMerah.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateTanggalMerah.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateTanggalMerah.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateTanggalMerah.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const tanggalMerahSelector = (state) => state.tanggalMerah;
